import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PinFrequencyHelper } from "@/Common/Helpers/PinFrequencyHelper";
import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

import styles from "./PinFrequencyOptionViewer.module.scss";

interface IPinFrequencyOptionViewerProps {
    employeeUIModel: EmployeeUIModel;
    loginPinFrequencyModel: LoginPinFrequencyModel;
}

export function PinFrequencyOptionViewer(props: IPinFrequencyOptionViewerProps): JSX.Element {
    const { getText } = useTranslation();

    const enableQuebecObstetricalPin = props.employeeUIModel?.isQuebecObstetricalFileEnabled() ?? false;
    const enableOntarioObstetricalPin = props.employeeUIModel?.isOntarioObstetricalFileEnabled() ?? false;
    const enableBritishColumbiaObstetricalPin = props.employeeUIModel?.isBritishColumbiaObstetricalFileEnabled() ?? false;

    const options = PinFrequencyHelper.getOptions(enableQuebecObstetricalPin, enableOntarioObstetricalPin, enableBritishColumbiaObstetricalPin);

    return (
        <div className={styles.container}>
            <div>
                {options.map(option => (
                    <div key={option} className={styles.optionLabelContainer}>
                        <span className={styles.optionPinFrequencyLabel}>
                            {getText(
                                PinFrequencyHelper.getLabelByPinFrequencyDocumentType(
                                    option,
                                    enableQuebecObstetricalPin,
                                    enableOntarioObstetricalPin,
                                    enableBritishColumbiaObstetricalPin
                                )
                            )}
                        </span>
                    </div>
                ))}
            </div>
            <div>
                {options.map(option => {
                    const frequency = PinFrequencyHelper.getFrequency(props.loginPinFrequencyModel, option);
                    const label = PinFrequencyHelper.getLabelByPinFrequency(frequency);

                    return (
                        <div key={option}>
                            <span>{getText(label)}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
